export const productFormSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "Product name",
      description: "The display name of the product",
      minLength: 1,
    },
    slug: {
      type: "string",
      title: "Slug",
      minLength: 1,
    },
    imageUrl: {
      type: ["string", "null"],
      title: "Product image",
      description: "Product image",
    },
    category: {
      type: "string",
      title: "Product Group",
      description: "The product group(s) this product belongs to",
    },
    keywords: {
      type: "array",
      title: "Keywords",
      description: "List of keywords associated with this product",
      items: {
        type: "string",
      },
    },
    metadata: {
      type: "object",
      title: "Product Details",
      properties: {
        sku: {
          type: "string",
          title: "EAN/UPC",
          minLength: 1,
        },
      },
      required: ["sku"],
    },
  },
  required: ["name", "metadata"],
};

export const productInfoUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/imageUrl",
      component: "singleImageUpload",
      options: {
        description: "Drag and drop your file here (only .jpg, .png)",
        shortDescription: "Product image (JPG, PNG)",
      },
    },
    {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/name",
          options: {
            placeholder: "Type name",
          },
        },
        {
          type: "Control",
          scope: "#/properties/metadata/properties/sku",
          options: {
            placeholder: "Type",
          },
        },
      ],
    },
  ],
};

export const productFileUploadJsonSchema = {
  type: "object",
  properties: {
    productFileData: {
      type: "array",
      items: { type: "object" },
      title: "",
      minItems: 1,
    },
  },
  required: ["productFileData"],
};

export const productFileUploadUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/productFileData",
      component: "partnerFileUpload",
      accept: ".csv",
      isPartnerRequired: false,
      description: "Select a comma-separated CSV file with product data",
    },
  ],
};

export const productFilterSchema = {
  type: "object",
  properties: {
    name: { type: "string", title: "Name" },
    sku: { type: "string", title: "EAN/UPC" },
  },
};

export const productFilterUISchema = {
  type: "HorizontalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/name",
      options: { placeholder: "Name" },
    },
    {
      type: "Control",
      scope: "#/properties/sku",
      options: { placeholder: "EAN/UPC" },
    },
  ],
};
